import {IFetchUserConfigAction, ISetUserConfigAction} from './types/userConfig.types';
import {UserConfig} from '../../incase-domain/user';

export const FETCH_USER_CONFIG_ACTION = 'FETCH_USER_CONFIG_ACTION';
export const SET_USER_CONFIG_ACTION = 'SET_USER_CONFIG_ACTION';

export const fetchUserConfigAction = (userId: string): IFetchUserConfigAction => ({
    type: FETCH_USER_CONFIG_ACTION,
    payload: userId,
});

export const setUserConfigAction = (userConfig: UserConfig): ISetUserConfigAction => ({
    type: SET_USER_CONFIG_ACTION,
    payload: userConfig,
});
